import React, { useState, useEffect } from 'react';
import axios from 'axios';

const PatientFlow = () => {
  const [queues, setQueues] = useState([]);
  const [form, setForm] = useState({
    patientId: '',
    type: 'OPD',
    priority: 0,
    location: '',
  });

  useEffect(() => {
    fetchQueues();
  }, []);

  const fetchQueues = async () => {
    try {
      const response = await axios.get(`${window.location.protocol}//${window.location.hostname}/api/patient-flow`);
      setQueues(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${window.location.protocol}//${window.location.hostname}/api/patient-flow`, form);
      setForm({
        patientId: '',
        type: 'OPD',
        priority: 0,
        location: '',
      });
      fetchQueues();
    } catch (error) {
      console.error(error);
    }
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  return (
    <div>
      <h2>Patient Flow</h2>
      <form onSubmit={handleSubmit}>
        <input name="patientId" placeholder="Patient ID" value={form.patientId} onChange={handleChange} required />
        <select name="type" value={form.type} onChange={handleChange}>
          <option value="OPD">OPD</option>
          <option value="IPD">IPD</option>
          <option value="walk-in">Walk-in</option>
          <option value="virtual">Virtual</option>
        </select>
        <input name="priority" type="number" placeholder="Priority" value={form.priority} onChange={handleChange} />
        <input name="location" placeholder="Location" value={form.location} onChange={handleChange} />
        <button type="submit">Add to Queue</button>
      </form>
      <h3>Queue List</h3>
      <ul>
        {queues.map(queue => (
          <li key={queue.id}>
            Patient {queue.patientId} - {queue.type} - Status: {queue.status} - Location: {queue.location}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PatientFlow;